{
  "version": 1,
  "asset_id": "3a70c250-a3d4-4fb6-b430-722a7428b66a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/3a70c250-a3d4-4fb6-b430-722a7428b66a/reflux-sleeve-after.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/3a70c250-a3d4-4fb6-b430-722a7428b66a/reflux-sleeve-after.png",
  "original_filename": "reflux-sleeve-after.png",
  "size": 113700,
  "content_type": "image/png",
  "created_at": "2026-09-13T20:58:45Z"
}
